import React, { useState, useEffect, useCallback } from "react";
import ProdutoTabela from "./ProdutoTabela";
import ProdutoFormulario from "./ProdutoFormulario";
import { Button, Modal, Box, Paper, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PermissionGate from "../CadastroPerfilUsuario/PermissionGate";
import URLManager from "../funcionalidadeNavbar/URLManager";


const Produto = () => {

    const _url =URLManager.getBaseURL()

    const produto = {
        idProduto: 0,
        image: '',
        cor: '',
        nomeModelo: '',
        marca: '',
        referencia: '',
        idEmpresa: 0,
        status: ''
    };
    const [objproduto, setObjProduto] = useState(produto)
    const [popperMessage, setPopperMessage] = useState('');
    const [fichaTecnica] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [bntproduto, setBtnProduto] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const navigate = useNavigate(); // Hook para navegação
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [mostrarCopiarItems, setMostrarCopiarItems] = useState(false);
    const [dadosExclusao, setDadosExclusao] = useState(null);
    // const [modoCopia, setModoCopia] = useState(false);
    // const [produtoSelecionado, setProdutoSelecionado] = useState(null);
    const [produtosFiltrados, setprodutosFiltrados] = useState(produtos);

    const filtrarNomeModelo = (nomeModelo) => {
        if (!nomeModelo) {
            setprodutosFiltrados(produtos); // Resetar a lista filtrada para todos os produtos
        } else {
            const resultado = produtos.filter((obj) =>
                obj.nomeModelo.toLowerCase().includes(nomeModelo.toLowerCase())
            );
            
            setprodutosFiltrados(resultado);
        }
    };

    const filtrarMarca = (marca) => {
        if (!marca) {
            setprodutosFiltrados(produtos); // Resetar a lista filtrada para todos os produtos
        } else {
            const resultado = produtos.filter((obj) =>
                obj.marca.toLowerCase().includes(marca.toLowerCase())
            );
            console.log("Filtrado por Marca:", resultado);
            setprodutosFiltrados(resultado);
        }
    };

    const [modoCopia, setModoCopia] = useState(false);

    const [modoCadastro, setModoCadastro] = useState(false);

    const handleCopiarFicha = (idProduto) => {
        selecionarProduto(idProduto);
        setModoCopia(true); // Ativar modo cópia
    };

    const handleCadastra = () => {
        limparproduto();
        setModoCopia(false);
        setModoCadastro(true);
        setOpenModal(true);
    };


    const handleOpenConfirmModal = async () => {
        try {
            // Buscar informações relacionadas ao produto antes de excluir
            const idProduto = objproduto.idProduto;
            
            // Buscar ficha técnica
            let temFichaTecnica = false;
            try {
                const resFicha = await fetch(`${_url}/fichaTecnica/produto/${idProduto}`, {
                    method: 'GET',
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                    }
                });
                if (resFicha.ok) {
                    const ficha = await resFicha.json();
                    temFichaTecnica = Array.isArray(ficha)
                        ? ficha.length > 0
                        : Boolean(ficha && (ficha.id || ficha.idFichaTecnica));
                }
            } catch (e) {
                console.log('Sem ficha técnica');
            }

            // Buscar teste de calce (usa query parameter ?produtoId=)
            let temTesteCalce = false;
            try {
                const resCalce = await fetch(`${_url}/teste-calce?produtoId=${idProduto}`, {
                    method: 'GET',
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                    }
                });
                if (resCalce.ok) {
                    const calce = await resCalce.json();
                    temTesteCalce = Array.isArray(calce) && calce.length > 0;
                }
            } catch (e) {
                console.log('Sem teste de calce');
            }

            // Verificar se produto tem catálogo virtual (verificar se tem imagem ou dados de catálogo)
            // Como o catálogo é parte do próprio produto, vamos verificar se tem dados preenchidos
            let temCatalogo = false;
            try {
                // Buscar detalhes completos do produto para verificar dados de catálogo
                const resProduto = await fetch(`${_url}/produto/${idProduto}`, {
                    method: 'GET',
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                    }
                });
                if (resProduto.ok) {
                    const prod = await resProduto.json();
                    // Considerar que tem catálogo se tiver imagem
                    temCatalogo = prod && prod.image && prod.image.length > 0;
                }
            } catch (e) {
                console.log('Erro ao verificar catálogo');
            }

            // Buscar variações de cor (endpoint correto: /produto/{id}/variacoes)
            let variacoes = 0;
            try {
                const resVariacoes = await fetch(`${_url}/produto/${idProduto}/variacoes`, {
                    method: 'GET',
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                    }
                });
                if (resVariacoes.ok) {
                    const vars = await resVariacoes.json();
                    variacoes = Array.isArray(vars) ? vars.length : 0;
                }
            } catch (e) {
                console.log('Sem variações');
            }

            setDadosExclusao({
                temFichaTecnica,
                temTesteCalce,
                temCatalogo,
                variacoes
            });
        } catch (error) {
            console.error('Erro ao buscar informações de exclusão:', error);
            setDadosExclusao({
                temFichaTecnica: false,
                temTesteCalce: false,
                temCatalogo: false,
                variacoes: 0
            });
        }
        setOpenConfirmModal(true);
    };

    const handleCloseConfirmModal = () => {
        setOpenConfirmModal(false);
    };

    const mostrarMensagem = (mensagem) => {
        setPopperMessage(mensagem);
        setSnackbarOpen(true);
        setTimeout(() => setSnackbarOpen(false), 3000);
    };

    const handleCloseSnackbar = () => setSnackbarOpen(false);

    const eventoTeclado = (e) => {
        setObjProduto({ ...objproduto, [e.target.name]: e.target.value });
    };

    const consultarFichaIdPorduto = (idProduto) => {
        fetch(`${_url}/fichaTecnica/fichaTecnica/${idProduto}`, {
            method: 'GET',
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
            }
        })
            .then((res) => res.json())
            .then((data) => {
                navigate(`/itemsDafichaTecnica/ItemsFichaTecnica/recarregarItemsFicha`);

            })
    }

    //função para atualizar a Tabela de Produto(reload)
    const carregarProduto = useCallback(() => {
                fetch(`${_url}/produto/so-pais`, {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                    }
                })
                .then((retorno) => retorno.json())
                .then((dadosProduro) => {
                                        console.log("Dados carregados:", dadosProduro);
                                        // Backend garante que o retorno é um array de produtos pai
                                        const produtosComId = (Array.isArray(dadosProduro) ? dadosProduro : []).map(prod => ({
                                                ...prod,
                                                idProduto: prod.idProduto || prod.id
                                        }));
                    setProdutos(produtosComId);
                    setprodutosFiltrados(produtosComId); // Atualize ambos os estados
                })
        .catch((error) => console.error('Erro ao carregar Produto:', error));
      }, [_url]);


    const cadastrarFichaTecnica = async (idProduto) => {
        if (!idProduto || isNaN(Number(idProduto))) {
            mostrarMensagem("ID do produto inválido. Não é possível cadastrar ficha técnica.");
            return;
        }
        try {
            // 1. Consultar se já existe ficha técnica para o produto
            const consulta = await fetch(`${_url}/fichaTecnica/produto/${idProduto}`, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                }
            });
            if (consulta.ok) {
                const fichas = await consulta.json();
                // Se vier array e tiver pelo menos uma ficha, usa a primeira
                if (Array.isArray(fichas) && fichas.length > 0 && fichas[0].id) {
                    const idFichaTecnica = fichas[0].idFichaTecnica || fichas[0].id;
                    mostrarMensagem("Ficha Técnica já existe. Redirecionando...");
                    return navigate(`/itemsDafichaTecnica/ItemsFichaTecnica/${idFichaTecnica}/${idProduto}`);
                }
            }
            // 2. Se não existe, cadastra nova ficha técnica
            const res = await fetch(`${_url}/fichaTecnica/cadastrarConsultar/${idProduto}`, {
                method: 'POST',
                body: JSON.stringify(fichaTecnica),
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                }
            });
            if (!res.ok) {
                const error = await res.json();
                mostrarMensagem(error.message || "Erro ao cadastrar ficha técnica.");
                return;
            }
            const data = await res.json();
            const idFichaTecnica = data.idFichaTecnica || data.id;
            mostrarMensagem("Ficha Técnica criada com sucesso!");
            navigate(`/itemsDafichaTecnica/ItemsFichaTecnica/${idFichaTecnica}/${idProduto}`);
        } catch (error) {
            console.error("Erro ao cadastrar/consultar ficha técnica:", error);
            mostrarMensagem("Erro ao cadastrar/consultar ficha técnica");
        }
    };

    // Estado e função para carregar variações (inclui o produto pai como primeira entrada)
    const [variacoesProduto, setVariacoesProduto] = useState([]);

    const carregarVariacoes = useCallback(async (parentId) => {
        try {
            console.log('[DEBUG] Produto.carregarVariacoes parentId:', parentId);
            if (!parentId) {
                console.log('[DEBUG] Produto.carregarVariacoes sem parentId, limpando variacoes');
                setVariacoesProduto([]);
                return;
            }
            const headers = { Accept: 'application/json', Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` };
            // Busca o produto pai
            const paiResp = await fetch(`${_url}/produto/${parentId}`, { headers });
            const produtoPai = paiResp.ok ? await paiResp.json() : null;

            console.log('[DEBUG] Produto.carregarVariacoes produtoPai raw:', produtoPai);

            // Busca variações (filhos)
            const varsResp = await fetch(`${_url}/produto/${parentId}/variacoes`, { headers });
            const filhos = varsResp.ok ? await varsResp.json() : [];
            console.log('[DEBUG] Produto.carregarVariacoes filhos raw:', filhos);

            const lista = [];
            if (produtoPai) lista.push({ ...produtoPai, idProduto: produtoPai.idProduto || produtoPai.id });
            if (Array.isArray(filhos)) {
                filhos.forEach(f => lista.push({ ...f, idProduto: f.idProduto || f.id }));
            }
            console.log('[DEBUG] Produto.carregarVariacoes lista final:', lista);
            setVariacoesProduto(lista);
        } catch (e) {
            console.error('Erro ao carregar variações:', e);
            setVariacoesProduto([]);
        }
    }, [_url]);



    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setObjProduto({ ...objproduto, image: reader.result });
            };
            reader.readAsDataURL(file);
        }
    };

    // const atualizarListaProdutos = (produto) => {
    //     setProdutos((prev) => [...prev, produto]);
    // };

    const cadastrarProduto = () => {
        if (!objproduto?.image) { // Verificação segura com optional chaining
            mostrarMensagem("Por favor, importe uma imagem.");
            return; // Impede a execução do restante do código
        }
        const formData = new FormData();

        if (objproduto.image) {
            const imageBlob = dataURItoBlob(objproduto.image);
            formData.append("imageFile", imageBlob, "produto.png");
        }


        formData.append("produto", new Blob([JSON.stringify({
            nomeModelo: objproduto.nomeModelo,
            marca: objproduto.marca,
            referencia: objproduto.referencia,
            cor: objproduto.cor,
            status: objproduto.status
        })], { type: "application/json" }));

        fetch(`${_url}/produto`, {
            method: 'POST',
            body: formData,
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
            }

        })

            .then((retorno) => retorno.json())
            .then((retorno_convertido) => {
                if (retorno_convertido.mensagem) {
                    mostrarMensagem(retorno_convertido.mensagem);
                } else {
                    setProdutos([...produtos, retorno_convertido]);
                    mostrarMensagem('Produto cadastrado com sucesso!');
                    limparproduto();
                    handleCloseModal();
                    carregarProduto();
                    setBtnProduto(true);
                }
            })
            .catch((erro) => {
                console.error('Erro ao cadastrar produto:', erro);
                mostrarMensagem('Erro ao cadastrar produto.');
            });
    };

    const alterarProduto = async () => {
        const formData = new FormData();

        // Verifique se a imagem foi fornecida e alterada
        if (objproduto.image && objproduto.image.startsWith('data:image')) {
            const imageBlob = dataURItoBlob(objproduto.image);
            formData.append("imageFile", imageBlob, "produto.png");

        } else {
            const emptyBlob = new Blob([], { type: 'image/png' });
            formData.append("imageFile", emptyBlob, "produto.png");
        }

        // Enviar os dados do produto (mesmo sem imagem, se necessário)
        formData.append('produto', new Blob([JSON.stringify({
            idProduto: objproduto.idProduto,
            nomeModelo: objproduto.nomeModelo,
            marca: objproduto.marca,
            referencia: objproduto.referencia,
            cor: objproduto.cor,
            status: objproduto.status
        })], { type: "application/json"}));
        fetch(`${_url}/produto/alterar/${objproduto.idProduto}`, {
            method: 'PUT',
            body: formData,
            headers: {
                
                Accept: "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
              }
        })
            .then(response => response.json())
            .then(data => {
                if (data.mensagem) {
                    alert(data.mensagem);
                } else {
                    const updatedItemsProduto = produtos.map(pro =>
                        pro.idProduto === objproduto.idProduto ? { ...pro, ...objproduto } : pro
                    );
                    setProdutos(updatedItemsProduto);
                    mostrarMensagem("Produto salterado com sucesso")
                    limparproduto();
                    carregarProduto();
                    handleCloseModal();
                }
            })
            .catch(error => {
                console.error('Erro ao alterar produto:', error);
                mostrarMensagem('Erro ao alterar produto');

            });

    }



    const remover = async () => {
        try {
            const idEmpresa =
                (objproduto?.idEmpresa && typeof objproduto.idEmpresa === 'object')
                    ? (objproduto.idEmpresa.id || null)
                    : (objproduto?.idEmpresa || null);

            const endpointComQuery = idEmpresa
                ? `${_url}/produto/remover/${objproduto.idProduto}?idEmpresa=${idEmpresa}`
                : `${_url}/produto/remover/${objproduto.idProduto}`;

            let response = await fetch(endpointComQuery, {
                method: 'DELETE',
                headers: {
                    Accept: "application/json, text/plain",
                    Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                }
            });

            if (!response.ok && idEmpresa) {
                const endpointAlternativo = `${_url}/produto/remover/${objproduto.idProduto}/${idEmpresa}`;
                response = await fetch(endpointAlternativo, {
                    method: 'DELETE',
                    headers: {
                        Accept: "application/json, text/plain",
                        Authorization: `Bearer ${sessionStorage.getItem("usuarioToken")}`
                    }
                });
            }

            const rawBody = await response.text();
            let mensagemBackend = rawBody;

            try {
                const body = rawBody ? JSON.parse(rawBody) : null;
                mensagemBackend = body?.mensagem || body?.message || rawBody;
            } catch (_) {
                mensagemBackend = rawBody;
            }

            if (!response.ok) {
                throw new Error(mensagemBackend || 'Não foi possível remover o produto.');
            }

            const mensagemFormatada = (mensagemBackend || 'Produto removido com sucesso.').replace(/\n+/g, ' | ').trim();
            mostrarMensagem(mensagemFormatada);
            handleCloseConfirmModal();
            limparproduto();
            carregarProduto();
        } catch (error) {
            mostrarMensagem(error?.message || 'Erro ao remover produto.');
            console.error('Erro ao remover produto:', error);
        }
    };

    const dataURItoBlob = (dataURI) => {
        // Verifica se a string está no formato correto
        if (!dataURI || !dataURI.startsWith('data:image')) {
            throw new Error('A string fornecida não é uma imagem base64 válida.');
        }
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };

    // const alternarModoCopia = () => {
    //     setModoCopia(!modoCopia);
    //     setProdutoSelecionado(null)
    //     setMostrarCopiarItems(!mostrarCopiarItems);
    // }

    // cria uma cópia do produto como PAI (sem colorVariation) e copia itens de ficha
    const copiarComoPai = async (produtoIdArg) => {
        try {
            const idToCopy = produtoIdArg || objproduto?.idProduto;
            if (!idToCopy) {
                mostrarMensagem('Produto não selecionado para copiar.');
                return;
            }

            // construir FormData multipart conforme backend espera (@RequestParam imageFile e @RequestPart produto)
            const formData = new FormData();
            // anexar imagem se for dataURI, senão enviar blob vazio para não quebrar o multipart
            if (objproduto?.image && typeof objproduto.image === 'string' && objproduto.image.startsWith('data:')) {
                const imageBlob = dataURItoBlob(objproduto.image);
                formData.append('imageFile', imageBlob, 'produto.png');
            } else {
                // anexa um arquivo vazio para manter compatibilidade (backend pode ignorar)
                formData.append('imageFile', new Blob([], { type: 'image/png' }), 'empty.png');
            }

            const idEmpresaVal = (objproduto && objproduto.idEmpresa && typeof objproduto.idEmpresa === 'object') ? (objproduto.idEmpresa.id || null) : objproduto.idEmpresa;
            const produtoDTO = {
                nomeModelo: objproduto?.nomeModelo || '',
                marca: objproduto?.marca || '',
                referencia: objproduto?.referencia || '',
                cor: objproduto?.cor || '',
                status: objproduto?.status || '',
                idEmpresa: idEmpresaVal || null
            };
            formData.append('produto', new Blob([JSON.stringify(produtoDTO)], { type: 'application/json' }));

            // chamada ao novo endpoint que copia produto como pai
            // POST /produto/{idProduto}/copiar-como-pai expects nomeModelo, referencia, imageFile
            formData.append('nomeModelo', objproduto?.nomeModelo || '');
            formData.append('referencia', objproduto?.referencia || '');

            const res = await fetch(`${_url}/produto/${idToCopy}/copiar-como-pai`, {
                method: 'POST',
                body: formData,
                headers: {
                    // let browser set Content-Type (multipart boundary)
                    Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
                }
            });

            if (!res.ok) {
                const txt = await res.text();
                throw new Error(txt || `Erro ao copiar produto como pai: ${res.status}`);
            }

            // backend retorna { produto, fichaIds }
            const created = await res.json();
            if (created && created.warningMessage) {
                mostrarMensagem(created.warningMessage);
            }

            // opcional: atualizar estado com o produto retornado
            const newProd = created.produto || created;
            if (newProd && (newProd.idProduto || newProd.id)) {
                const pid = newProd.idProduto || newProd.id;
                try {
                    const prodResp = await fetch(`${_url}/produto/${pid}`, { headers: { Accept: 'application/json', Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
                    if (prodResp.ok) {
                        const prodJson = await prodResp.json();
                        setObjProduto(prodJson);
                    }
                } catch (e) {
                    console.warn('Não foi possível buscar produto criado imediatamente:', e);
                }
            }

            mostrarMensagem('Produto copiado como pai com sucesso!');
            carregarProduto();
            handleCloseModal();
        } catch (erro) {
            console.error('Erro ao copiar como pai:', erro);
            mostrarMensagem('Erro ao copiar como pai. ' + (erro.message || ''));
        }
    };

    // cria variação de cor (filho) do produto
    const criarVariacaoCor = async (produtoIdArg) => {
        try {
            const idToCopy = produtoIdArg || objproduto?.idProduto;
            if (!idToCopy) {
                mostrarMensagem('Produto não selecionado para criar variação.');
                return;
            }
            const cor = objproduto?.cor || '';
            if (!cor) {
                mostrarMensagem('Informe a cor para a nova variação antes de criar.');
                return;
            }
            // build multipart FormData so backend receives nomeModelo and referencia and optional image
            const formData = new FormData();
            formData.append('cor', cor);
            formData.append('nomeModelo', objproduto?.nomeModelo || '');
            formData.append('referencia', objproduto?.referencia || '');
            if (objproduto?.image && typeof objproduto.image === 'string' && objproduto.image.startsWith('data:')) {
                const imageBlob = dataURItoBlob(objproduto.image);
                formData.append('imageFile', imageBlob, 'produto.png');
            }

            const res = await fetch(`${_url}/produto/${idToCopy}/copiar-com-cor`, {
                method: 'POST',
                body: formData,
                headers: {
                    // let browser set Content-Type (multipart boundary)
                    Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
                }
            });

            if (!res.ok) {
                const txt = await res.text();
                throw new Error(txt || `Erro ao criar variação: ${res.status}`);
            }

            const created = await res.json();
            if (created && created.warningMessage) {
                mostrarMensagem(created.warningMessage);
            }
            // response may contain { produto, fichaIds }
            const newProd = created.produto || created;
            const fichaIds = created.fichaIds || [];
            const fichaId = fichaIds.length ? fichaIds[0] : null;

            // setar produto criado/atualizado no estado local
            if (newProd && (newProd.idProduto || newProd.id)) {
                const pid = newProd.idProduto || newProd.id;
                try {
                    // busca o produto recém-criado/atualizado para garantir dados completos
                    const prodResp = await fetch(`${_url}/produto/${pid}`, { headers: { Accept: 'application/json', Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
                    if (prodResp.ok) {
                        const prodJson = await prodResp.json();
                        setObjProduto(prodJson);
                    }
                } catch (e) {
                    console.warn('Não foi possível buscar produto criado imediatamente:', e);
                }
            }

            mostrarMensagem('Variação criada com sucesso!');
            // recarrega lista de produtos para refletir a nova variação
            await carregarProduto();
            handleCloseModal();

            // tentar recarregar variações do parent para manter consistência (não há estado de variacoes aqui, mas isso ajuda o backend/cache)
            try {
                const parentId = objproduto.parentProductId || objproduto.idProduto || (newProd.parentProductId || newProd.idProduto);
                if (parentId) {
                    await fetch(`${_url}/produto/${parentId}/variacoes`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
                }
            } catch (e) {
                console.warn('Falha ao recarregar variações do parent:', e);
            }

            // navegar para a nova variação usando fichaId quando disponível
            if (fichaId) {
                navigate(`/itemsDafichaTecnica/ItemsFichaTecnica/${fichaId}/${newProd.idProduto || newProd.id}`);
            }
        } catch (erro) {
            console.error('Erro ao criar variação de cor:', erro);
            mostrarMensagem('Erro ao criar variação. ' + (erro.message || ''));
        }
    };


    const limparproduto = () => {
        setObjProduto({
            idProduto: 0,
            image: '',
            nomeModelo: '',
            marca: '',
            referencia: '',
            cor: '',
            status:'',
        });
        setBtnProduto(true);
    };

    const selecionarProduto = (id) => {
        let vetorTemp = [...produtos];
        let indice = vetorTemp.findIndex((p) => p.idProduto === id);
        setObjProduto(produtos[indice]);
        setBtnProduto(false);
        setMostrarCopiarItems(true);
        setOpenModal(true);
        setModoCopia(false);
        setModoCadastro(false)
    };

    const handleOpenModal = () => {
        limparproduto();
        setMostrarCopiarItems(false);
        setModoCadastro(false)
        setOpenModal(true);

    };

    const handleCloseModal = () => {
        limparproduto();
        setOpenModal(false);
    };

    useEffect(() => {
        carregarProduto();
    }, [carregarProduto]);


    return (
        <div>
            <PermissionGate permissions={["produtoCadastrar"]}>
            <div className="button-cadastrarProduto">
                <Button variant="contained" onClick={handleCadastra}>
                    Cadastrar Produto
                </Button>
            </div>
            </PermissionGate>

            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <Box
                    sx={{
                    position: "absolute",
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%,-50% )',
                    width: 600,
                    maxHeight: '200vh',
                    overflowY: 'auto',
                    p: 3,
                }}
                >
                    <Paper style={{
                                padding: '15px',
                                color: '#333',
                                textAlign: 'center',
                                fontSize: '16px',
                                borderRadius: '20px',
                                background: 'rgba(255, 255, 255, 0.98)',
                                backdropFilter: 'blur(20px)',
                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
                                position: 'relative',
                                overflow: 'hidden'
                              }}>
                        <ProdutoFormulario
                            obj={objproduto}
                            alterarProduto={alterarProduto}
                            produtos={produtos}
                            botao={bntproduto}
                            eventoTeclado={eventoTeclado}
                            handleImageChange={handleImageChange}
                            cadastrarProduto={cadastrarProduto}
                            remover={handleOpenConfirmModal}
                            copiarComoPai={copiarComoPai}
                            criarVariacaoCor={criarVariacaoCor}
                            variacoes={variacoesProduto}
                            carregarVariacoes={carregarVariacoes}
                            mostrarCopiarItems={mostrarCopiarItems}
                            filtrarNomeModelo={filtrarNomeModelo}
                            filtrarMarca={filtrarMarca}
                            modoCopia={modoCopia}
                            modoCadastro={modoCadastro}
                            mostrarMensagem={mostrarMensagem}
                            handleOpenModal={handleOpenModal}
                            handleCopiarFicha={handleCopiarFicha}


                        />
                        <Button onClick={handleCloseModal} variant="contained" sx={{ marginTop: '20px' }}>
                            Fechar
                        </Button>
                    </Paper>
                </Box>
            </Modal>

            <ProdutoTabela
                vetor={produtosFiltrados}
                selecionarProduto={selecionarProduto}
                exibirFichaTecnica={cadastrarFichaTecnica}
                consultarFichaIdPorduto={consultarFichaIdPorduto}
                filtrarNomeModelo={filtrarNomeModelo}
                filtrarMarca={filtrarMarca}
                vetrores={produtos}
                setModoCopia={setModoCopia}

            />
            {/* Modal de Confirmação */}
            <Modal open={openConfirmModal} onClose={handleCloseConfirmModal}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 500,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <h2>Confirmação de Exclusão</h2>
                    <p><strong>Tem certeza que deseja remover este produto?</strong></p>
                    
                    {dadosExclusao && (
                        <div style={{ 
                            marginTop: '15px', 
                            padding: '10px', 
                            backgroundColor: '#fff3cd', 
                            border: '1px solid #ffc107',
                            borderRadius: '5px',
                            textAlign: 'left'
                        }}>
                            <p style={{ margin: '5px 0', fontWeight: 'bold', color: '#856404' }}>
                                Os seguintes dados também serão removidos:
                            </p>
                            <ul style={{ margin: '10px 0', paddingLeft: '20px', color: '#856404' }}>
                                {dadosExclusao.temFichaTecnica && (
                                    <li>Ficha Técnica e seus itens</li>
                                )}
                                {dadosExclusao.temTesteCalce && (
                                    <li>Teste de Calce</li>
                                )}
                                {dadosExclusao.temCatalogo && (
                                    <li>Catálogo Virtual</li>
                                )}
                                {dadosExclusao.variacoes > 0 && (
                                    <li>{dadosExclusao.variacoes} variação(ões) de cor</li>
                                )}
                                {!dadosExclusao.temFichaTecnica && 
                                 !dadosExclusao.temTesteCalce && 
                                 !dadosExclusao.temCatalogo && 
                                 dadosExclusao.variacoes === 0 && (
                                    <li>Apenas o produto (sem dados vinculados)</li>
                                )}
                            </ul>
                        </div>
                    )}
                    
                    <Button onClick={remover} variant="contained" color="error" sx={{ marginRight: 2, marginTop: 2 }}>
                        Sim, Remover
                    </Button>
                    <Button onClick={handleCloseConfirmModal} variant="outlined" sx={{ marginTop: 2 }}>
                        Cancelar
                    </Button>
                </Box>
            </Modal>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                message={popperMessage}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
        </div>
    );
};

export default Produto;
